import { render, staticRenderFns } from "./V2Pricing.vue?vue&type=template&id=288bc06a&scoped=true&"
import script from "./V2Pricing.vue?vue&type=script&lang=js&"
export * from "./V2Pricing.vue?vue&type=script&lang=js&"
import style0 from "./V2Pricing.vue?vue&type=style&index=0&id=288bc06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bc06a",
  null
  
)

export default component.exports